/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Dialog from '@material-ui/core/Dialog';
import withStyles from '@material-ui/core/styles/withStyles';
import DialogTitle from '@material-ui/core/DialogTitle';

const MiniCartStyle = ({ palette }) => ({
    modalContainer: {
        padding: '0px 40px',
        '& .MuiTypography-caption': {
            fontSize: '14px',
            color: (palette.contentColor || '#666666'),
        },
    },
    modalItem: {
        padding: '15px',
    },
    alignIcon: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
    },
    titleBorderBottom: {
        marginBottom: '5px',
        paddingBottom: '5px',
        borderBottom: `1px solid ${(palette.colorDisabled || '#ccc')}`,
    },
    addedCartItem: {
        color: (palette.cms?.miniCartGreen || '#00CC00'),
        flex: '1 0 auto',
        '& svg': {
            fontSize: '21px',
        },
        '& p': {
            fontWeight: '600',
            marginLeft: '4px',
        },
    },
    productTitle: {
        fontSize: '19px',
        fontWeight: '600',
    },
    productDescription: {
        '& p': {
            display: 'inline-block',
        },
        '& span, p': {
            marginRight: '15px',
        },
        marginBottom: '15px',
    },
    fontSize12: {
        fontSize: '12px !important',
    },
    priceAttributeContainer: {
        margin: '12px 0px 20px 0px',
        display: 'flex',
        '& p:first-child': {
            flex: '1',
        },
    },
    floatRight: {
        float: 'right',
    },
    productImageUI: {
        '& img': {
            width: '170px',
            height: '188px',
            border: `1px solid ${(palette.text?.primary || '#2F2F2F')}`,
        },
    },
    buttonDialogAction: {
        margin: '32px 0px 15px 0px',
        '& button': {
            color: palette?.white,
            backgroundColor: `${(palette.primaryButton || '#a1001a')} !important`,
            boxSizing: 'border-box',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            fontWeight: '700',
            width: '100%',
            height: '50px',
            fontSize: '1em',
            textTransform: 'uppercase',
            lineHeight: '1.46em',
            padding: '7px 24px 5px 24px',
        },
    },
    viewCartWrapper: {
        display: 'flex',
    },
    backToGiftListAction: {
        justifyContent: 'flex-start',
        width: '100%',
        '& p': {
            fontSize: '14px',
        },
        '& p, svg': {
            cursor: 'pointer',
        },
    },
    viewCartDialogAction: {
        justifyContent: 'flex-end',
        width: '100%',
        '& p': {
            fontSize: '14px',
        },
        '& p, svg': {
            cursor: 'pointer',
        },
    },
    chargesShippingContainer: {
        padding: '0px 15px 0px 80px',
    },
    textCenter: {
        textAlign: 'center',
    },
});

const StyledDialog = withStyles((theme) => ({
    root: {
        top: 'auto !important',
        bottom: 'auto !important',
        zIndex: '1100 !important',
    },
    paper: {
        maxWidth: '1132px',
        marginTop: '0px',
        borderRadius: '0px',
        [theme.breakpoints.up('md')]: {
            minWidth: 1132,
        },
    },
}))(Dialog);

const StyledDialogTitle = withStyles(() => ({
    root: {
        position: 'absolute',
        right: '0',
        padding: '0px 10px',
        '& svg': {
            fontSize: '30px',
        },
    },
}))(DialogTitle);

export {
    StyledDialog,
    StyledDialogTitle,
    MiniCartStyle,
};

export default MiniCartStyle;
